// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-bend-right';

export const Component = () => (
  <path d='M4.3 20.295C2.765 18.762 2 16.895 2 14.74c0-2.156.766-4.023 2.3-5.556C5.831 7.7 7.7 6.934 9.854 6.885h11.063l-4.071-4.07c-.096-.049-.144-.145-.144-.336 0-.335.144-.479.479-.479a.54.54 0 0 1 .383.144l4.885 4.885a.543.543 0 0 1 .144.383.435.435 0 0 1-.144.335l-4.885 4.885a.434.434 0 0 1-.335.144c-.335 0-.527-.144-.527-.48 0-.143.048-.238.144-.334l4.071-4.071H9.855c-1.868 0-3.496.67-4.838 2.011-1.389 1.341-2.06 2.97-2.06 4.838 0 1.868.671 3.496 2.06 4.837 1.34 1.39 2.97 2.06 4.838 2.06h7.327c.335 0 .527.143.527.479 0 .335-.192.479-.527.479H9.855c-2.156 0-4.023-.767-5.556-2.3Z' />
);

export const viewBox = '0 0 25 25';
